import { render, staticRenderFns } from "./ExpandingDisclaimer.vue?vue&type=template&id=7b22a3c6&"
import script from "./ExpandingDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ExpandingDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingDisclaimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports